import React from 'react';

const TableHead = () => (
    <thead className="thead-light">
        <tr>
            <th scope="col">Protocolo</th>
            <th scope="col">Descrição</th>
            <th scope="col">Valor</th>
            <th scope="col">Data</th>
            <th scope="col">Status</th>
            <th scope="col"></th>
        </tr>
    </thead>
);

export default TableHead;


// WEBPACK FOOTER //
// ./src/ZWallet/Operations/components/TableHead.js